// covered-by: frontends/carrie/src/routes/ask-puntt/components/__tests__/InheritedOrgTagChips.test.tsx
import { Badge, Flex } from "@radix-ui/themes";

/**
 * Read-only chips for tags inherited from linked project files.
 * Distinct from owned OrgLabelEditor chips — no remove affordance.
 */
export function InheritedOrgTagChips({
  tags,
  testIdPrefix = "inherited",
}: {
  tags: string[];
  testIdPrefix?: string;
}) {
  if (tags.length === 0) return null;

  return (
    <Flex
      wrap="wrap"
      gap="1"
      align="center"
      data-testid={`${testIdPrefix}-tags`}
      aria-label="Tags from file"
    >
      {tags.map((tag) => (
        <Badge
          key={tag.toLowerCase()}
          size="1"
          variant="soft"
          color="gray"
          title="From file"
          data-testid={`${testIdPrefix}-tag-${tag}`}
          className="opacity-80"
        >
          {tag}
        </Badge>
      ))}
    </Flex>
  );
}
